/**
 * @title ajax-modular.js: Feature level module
 * @description Utility module associated with ajax modular
 */
define([], function() {
  let AjaxModular = {
    /**
     * ID of the element that should receive focus after AJAX update.
     * Cleared after use.
     * @type {string|null}
     */
    pendingFocusId: null,

    /**
     * A generic function to make ajax requests. The only difference being
     * that this function sets a default done promise that injects html
     * into the DOM with the response data. Pass done, fail, and always
     * functions to the options object to be called in each respective promise.
     * @param  {Object} options Object containing options to pass to $.ajax
     *                          and functions to call within $.ajax promises.
     * @return {void}
     */
    ajax_update_state: function(options) {

      $('.order-ajax').addClass('ajax-busy');
      
      let checkoutPageName = (typeof checkoutPage === 'undefined') ? false : checkoutPage;
      if (options.page || checkoutPageName) {
        options.url = COSTCO.util.makeUrl(options.url, {
          'checkoutPage': options.page || checkoutPageName
        });
      }
      // For appending HTML, caller should override options property by setting
      // ajax_replace_content: COSTCO.AjaxModular.ajax_append_content
      // this will be reflected in ajax_update_default_done method (look below)
      if (!options.done) options.done = COSTCO.AjaxModular.ajax_update_default_done;
      if (!options.always) options.always = COSTCO.AjaxModular.ajax_update_default_always(options.inputContainer);
      COSTCO.util.ajax(options);
    },

    /**
     * Default implementation of the done promise used by ajax_update_state.
     * The data structure this function uses is defined in JSONLayout.jsp.
     * Update the state of each html segment. This assumes that the
     * property key maps to the id of the html segment to replace. Also,
     * if there any errors defined on the response_obj.error,
     * display them.
     * @param  {String} data       The JSON returned as a string. Contains
     *                             the encoded html that must be decoded
     *                             and then is injected into the DOM.
     * @param  {String} textStatus [description]
     * @param  {String} jqXHR      [description]
     * @param  {Object} options    The options object originally passed to
     *                             ajax_update_state
     * @return {void}
     */
    ajax_update_default_done: function(data, textStatus, jqXHR, options) {
      try {
        let response_obj = typeof(data) === 'object' ? data : JSON.parse(data);
        let defaultOptions = {
          ajax_replace_content: COSTCO.AjaxModular.ajax_replace_content,
          ajax_handle_errors: COSTCO.AjaxModular.ajax_handle_errors,
          ajax_update_post_done: function() {},
          error_container: '',
          scrollToError: true,
        };

        //trigger start event
        COSTCO.AjaxModular.triger_event('costco.ajax.content.update.start', response_obj, options.start_event);
        
        //override any defaults that came from options input parameter
        let mergedOptions = $.extend(true, {}, defaultOptions, options);
        
        // Inject New Html
        mergedOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
        
        // Post Html Injection
        mergedOptions.ajax_update_post_done(response_obj, mergedOptions, defaultOptions);
        
        // Handle any Errors and perform cleanup
        mergedOptions.ajax_handle_errors(response_obj, mergedOptions, defaultOptions);
        
        //trigger end event        
        COSTCO.AjaxModular.triger_event('costco.ajax.content.update.end', response_obj, options.end_event);
        
      } catch (e) {
        console.error(e);
      }
      console.log('ajax_update_default_done');
    },

    ajax_replace_content: function(response_obj, mergedOptions, defaultOptions) {
      Object.keys(response_obj.payload.html).forEach(function(key) {
        let encoded_html = response_obj.payload.html[key];
        if (mergedOptions.replaceKey) {
          if (mergedOptions.replaceKey.original == key) {
            key = mergedOptions.replaceKey.replace;
          }
        }
        $('#' + key).html(COSTCO.util.get_decoded_html(encoded_html));
        console.log('ajax_replace_content ' + key);
      });
    },

   /**
	  * Append content to the end of already existing div html 
	  */
    ajax_append_content: function(response_obj, mergedOptions, defaultOptions) {
      Object.keys(response_obj.payload.html).forEach(function(key) {
        var encoded_html = response_obj.payload.html[key];
        if (mergedOptions.replaceKey) {
          if (mergedOptions.replaceKey.original == key) {
            key = mergedOptions.replaceKey.replace;
          }
        }
        $('#' + key).append(COSTCO.util.get_decoded_html(encoded_html));
      });
    },    

    ajax_handle_errors: function(response_obj, mergedOptions, defaultOptions) {

      if (COSTCO.util.isBusinessDelivery()) {
        if (COSTCO.CreditCard && COSTCO.CreditCard.isCybersourceEnabled()) {
          $('.error:not(.error-qty-increment, #cc_cvc, #cc_cvc_err_msg)').empty();
        } else {
          $('.error:not(.error-qty-increment)').empty(); // clear any errors that may be on the page
        }
      } else {
        if (COSTCO.CreditCard && COSTCO.CreditCard.isCybersourceEnabled()) {
          $('.error:not(select, #cc_cvc, #cc_cvc_err_msg)').empty();
          $('.error:not(select)').removeClass('critical-notification');
        } else {
          $('.error:not(select)').empty().removeClass('critical-notification'); // clear any errors that may be on the page
        }
      }

      let error_container = mergedOptions.error_container;
      

      // TODO: This code is not part of ajax modular. Move it to a concrete function implementation
      // ### Author: START

      // if (typeof Checkout !== 'undefined' && (Checkout.isReviewPage() || Checkout.isPaymentPage())) {
    	//  if(typeof TokenGateway !== 'undefined'){
      //     TokenGateway.refreshGateway();
      //   }
    	//  if(response_obj.metadata && response_obj.metadata.quantityUpdatedForCashCardPaymentErr) {
      //   error_container = '#errquantity_application_';
      //   	  $('#errquantity_application_').addClass('critical-notification');
      //   	  $('#errquantity_application_').removeClass('error');
      //   	  $("#CheckoutPaymentForm input[name=doBillingPaymentCmd]").val('true');

      //   	  if($('#errquantity_application_').html().trim() == ''){
      //   		  $('#errquantity_application_').html(response_obj.metadata.quantityUpdatedForCashCardPaymentErr);
      //   	  }
    	//  }
    	//  else{
    	//   if(typeof COSTCO.CreditCard !== 'undefined'){
      //   		  COSTCO.CreditCard.init();
      //   	  }

  		//   if(typeof COSTCO.wallet !== 'undefined'){
      // ### Author: END


      // ### Author: START
  		// 	  //wallet module is not used in USBD - all other allow 
  		// 	  if (wcs.storeId !='11301') {
  		// 		  COSTCO.wallet.init();    				  
  		// 	  }
      // ### Author: END

      // ### Author: START
  		//   }
  		//   if(typeof COSTCO.CC !== 'undefined'){
  		// 	  COSTCO.CC.init();
  		//   }  
      //  }
      // }
      // ### Author: END
      

      let input_container = mergedOptions.input_container;
      let application = response_obj.error.application || [];
      let exception = response_obj.error.exception || [];
      let error_html = '';
      if (exception.length > 0) {
        error_html += '<p>An unexpected error has occured</p>';
      }
      application.forEach(function(error_message) {
        error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
      });
      // if there is a redirect, store the error in sessionStorage and redirect user,
      // otherwise error will show in error container
      if (response_obj.error.redirect) {
        if (typeof sessionStorage != 'undefined') {
          sessionStorage.setItem('errorMessage', error_html); // store error_html in sessionStorage to show on redirected page
        }
        document.location.href = '/' + response_obj.error.redirect;
        return;
      }
      if (typeof(error_container) === 'string') {
        error_container = $(error_container);
      }
      if (input_container) {
        if ((application.length + exception.length) > 0) {
          $(input_container).addClass('error');
          $(input_container).attr('aria-invalid', 'true');
        } else {
          $(input_container).removeClass('error');
          $(input_container).attr('aria-invalid', 'false');
        }
      }


      // TODO: Rename trigger to more general name
      if (error_container == '' || error_container.length == 0) {
        COSTCO.AjaxModular.triger_event('costco.ajax.content.update.sucess', response_obj);
        return;
      }
      error_container.children().remove();

      // TODO: This code is not part of ajax modular. Move it to a concrete function implementation
      // ### Author: START
      // if(response_obj.metadata.quantityUpdatedForCashCardPaymentErr && error_html.length > 0){
    	//  $(error_container).html('');
      // }
      // ### Author: END

      error_container.append(error_html);

      // TODO: This code is not part of ajax modular. Move it to a concrete function implementation
      // ### Author: START
      // if($('#errquantity_application_').length > 0 && $('#errquantity_application_').html().trim() != ''){
    	//  if(!COSTCO.OrderSummary.isAllPaidByCashCard()){
    	//   COSTCO.Checkout.showPaymentEditSection();
    	//  } 
    	//  else{
    	//   $('#errquantity_application_').html('');
    	//   $('#errquantity_application_').removeClass('critical-notification');
      //   	  $('#errquantity_application_').addClass('error');
    	//  }   	  
    	//  COSTCO.CC.init();
      // }
      // else if($('#errquantity_application_').length > 0){
    	//  $('#errquantity_application_').removeClass('critical-notification');
    	//  $('#errquantity_application_').addClass('error');
      // }
      // ### Author:  END


      // TODO: This code is not part of ajax modular. Move it to a concrete function implementation
      // ### Author: START
      //This will do the real work - I have no idea what the above code does.
      //This will place error messages in-line
      // if ($('#isBDAppVar').val() == 'BD') {
    	//  COSTCO.OrderItems.placeGlobalCartErrorsInLine(response_obj);
      // }
      // ### Author: END
      
      if (mergedOptions.scrollToError && COSTCO.util.has_errors(response_obj)) {

        // TODO: Rename trigger to more general name
        $('body').trigger('costco.ajax.content.update.error', response_obj);
        $('body, html').animate({
          scrollTop: $(error_container).offset().top - 30,
        }, 800);
      }
    },

   /**
    * Extracting default function out so we can perfom this and something else
    */
    ajax_update_default_always: function(inputContainer) {
      $('.order-ajax').removeClass('ajax-busy');
      COSTCO.Checkout.validator = undefined;
      // Create a function to focus back to the original input after
      // the ajax call is done
      // This will only be done only if there input is defined in the option payload
      if (inputContainer) {
        let focusInput = $(inputContainer);
        // If we have the id then lets use it
        if (focusInput[0].id) {
          console.log(focusInput[0].id);
          $('#' + focusInput[0].id).focus();
        } else {
          console.log('Working for it');
          // Ok no id so now we have to do work
          if (focusInput[0].nodeName == 'INPUT') {
            if (focusInput.attr('type') == 'radio' && focusInput.attr('name')) {
              $('input:checked[name="' + focusInput.attr('name') + '"]').focus();
            }
          }
        }
      }
    },

   /**
    * Triggers an event
    *
    * @param {String}   default_event   Required parameter. It is the default name of the event
                                        to be triggered in case that 'event' param is not passed
    * @param {Object}   response_obj    Object to be passed to event listener
    * @param {String}   event           Custom event name to be triggered. If not specified, 'defaultEvent' will be used
    *
    * @return {void}
    */
    triger_event: function(default_event, response_obj, event) {
      let eName = (typeof event === 'undefined') ? default_event : event;
      $('body').trigger(eName, response_obj);    	
    },    
  };
  
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = new Object();
  }
  window.COSTCO.AjaxModular = AjaxModular;
  return AjaxModular;
});


// WEBPACK FOOTER //
// ./js/global/ajax-modular.js